import { z } from "zod";

import {
  IndustrialProcessSchema,
  SurfaceTreatmentMethodSchema,
  SurfaceTreatmentTypeSchema,
} from "../generated/prisma/zod";

export const OnboardingProcessStepSchema = z.object({
  id: z.string().uuid(),
  industrialProcess: IndustrialProcessSchema,
  type: SurfaceTreatmentTypeSchema,
  machineName: z.string().nullable(),
  method: SurfaceTreatmentMethodSchema,
  price: z.number().int().nullable(),
  preparationTimeFormula: z.string().nullable(),
  cycleTimeFormula: z.string().nullable(),
});

export type OnboardingProcessStep = z.infer<typeof OnboardingProcessStepSchema>;
